import videojs from 'video.js';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';
import maps from './components/map';

import externalLinks from './components/external-links';
import header from './components/header';

require('./components/gallery');
require('./components/process-gallery');
require('./components/hero');

window.addEventListener('load', () => document.body.classList.remove('preload'));

document.addEventListener('DOMContentLoaded', () => {
	externalLinks.init();
	maps.init();
	header.init();
	if (document.querySelectorAll('.video-js')) {
		const videos = Array.from(document.querySelectorAll('.video-js'));
		videos.forEach((video) => {
			videojs(video);
		});
	}
});



// WEBPACK FOOTER //
// ./src/js/app.js